
import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName as projectCostLookupManagementServiceProviderName } from "."
export const vsObjectName = "projectCostCategory";

export const projectCostCategoryConfig = simpleLookupConfig(projectCostLookupManagementServiceProviderName, {
  name: vsObjectName,
  nameSingular: "Project Cost Category",
  namePlural: "Project Cost Categories",
  url: "/api/project/projectCostCategory",
  defaultSort: "Name"
})

